import { BinaryLinkModel } from "../links/binary/BinaryLinkModel";
import { ADDPORT } from "./ConstantNames";
import { UnBinaryNodeModel } from "./unbinary/UnBinaryNodeModel";
import { PortModelAlignment, PortModel } from "@projectstorm/react-diagrams";
export class NaryRelationPortModel extends PortModel {
  constructor(name = "default", alignment = PortModelAlignment.LEFT) {
    super({
      type: 'nary',
      name: name,
      alignment: alignment
    });
  }

  createLinkModel() {
    if (this.getMaximumLinks() === 0) {
      return null;
    }

    return new BinaryLinkModel();
  }

  canLinkToPort(port) {
    return port.getNode() instanceof UnBinaryNodeModel && port.getName() !== ADDPORT;
  }

}